import { Pipe, PipeTransform } from '@angular/core';
import { HistoryModel } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';

@Pipe({
    name: 'UpdateAppointmentHistoryPipe'
})
export class UpdateAppointmentHistoryPipe implements PipeTransform {

    constructor(
    ) { 
         // This is intentional
    }

    transform(deatils: string,forPlanning?:boolean): any {
        const arra = []
        let str = deatils.split("|")
        str.forEach(element => {
            let obj: HistoryModel = {
                isTable: false,
                lable: "",
                value: ""
            }
            obj.isTable = false;
            if (element?.toString().includes(":")) {
                let arr = [];
                if(forPlanning){
                    arr = element?.split("=");
                }
                else{
                    arr = element?.split(":");
                }
                if (element?.toString().includes("~")) {
                    obj.isTable = true;
                    obj.lable = arr[0]?.trim();
                    obj.value = arr[1].split("~");
                }
                else {
                    obj.isTable = false;
                    obj.lable = arr[0]?.trim();
                    if (arr.length > 2) {
                        obj.value = `${arr[1]?.trim()} - "${arr[2]?.trim()}"`;
                    } else {
                        obj.value = arr[1]?.trim();
                    }
                }
                arra.push(obj);
            }
        })
        arra.sort((x,y)=>{return x.isTable-y.isTable})
        return arra;
    }
}


